/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Liste complète des variables du tunnel ouvertes au valideur ; les autres sont fermées. Vide ferme tout.
 * @export
 * @interface SetVariablesValideurCommand
 */
export interface SetVariablesValideurCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof SetVariablesValideurCommand
     */
    variableValueIds: Array<string>;
}

/**
 * Check if a given object implements the SetVariablesValideurCommand interface.
 */
export function instanceOfSetVariablesValideurCommand(value: object): value is SetVariablesValideurCommand {
    if (!('variableValueIds' in value) || value['variableValueIds'] === undefined) return false;
    return true;
}

export function SetVariablesValideurCommandFromJSON(json: any): SetVariablesValideurCommand {
    return SetVariablesValideurCommandFromJSONTyped(json, false);
}

export function SetVariablesValideurCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetVariablesValideurCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueIds': json['variableValueIds'],
    };
}

export function SetVariablesValideurCommandToJSON(json: any): SetVariablesValideurCommand {
    return SetVariablesValideurCommandToJSONTyped(json, false);
}

export function SetVariablesValideurCommandToJSONTyped(value?: SetVariablesValideurCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueIds': value['variableValueIds'],
    };
}

